@if (colorLoader) {
  <div class="mh">
    <p-progressSpinner
      strokeWidth="5"
      fill="#EEEEEE"
      animationDuration=".5s"></p-progressSpinner>
  </div>
}

@if (!colorLoader) {
  <div>
    <div class="topedit">Solution Advisor incentives</div>
  </div>
}

@if (!colorLoader) {
  <app-incentive-details-header
    #incentiveDetailsHeader
    [incentiveDetails]="incentiveDetails"></app-incentive-details-header>
}

@if (!colorLoader) {
  <div class="scrollcontent boxtb">
    <p-tabs scrollable value="0" (onChange)="onTabChange($event)">
      <p-tablist>
        <p-tab value="0">Partner</p-tab>
        <p-tab value="1">Payment Profile</p-tab>
        <p-tab value="2">Customer Details</p-tab>
        <p-tab value="3">Incentive Details</p-tab>
        <p-tab value="4">Incentive Payment Information</p-tab>
        <p-tab value="5">Incentive Payment Milestone 2</p-tab>
        @if (!isMCIWorkshop) {
          <p-tab value="6">POE Submission</p-tab>
        }
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel value="0">
          <app-partner-details
            [incentiveDetails]="incentiveDetails"
            (refreshPartnerInput)="refresh()"></app-partner-details>
        </p-tabpanel>
        <p-tabpanel value="1">
          <app-payment-profile
            [partnerPaymentDetails]="
              profilePaymentDetails
            "></app-payment-profile>
        </p-tabpanel>
        <p-tabpanel value="2">
          <app-customer-details
            [incentiveDetails]="incentiveDetails"
            (refreshPartnerInput)="refresh()"></app-customer-details>
        </p-tabpanel>
        <p-tabpanel value="3">
          <app-incentive-details
            [incentiveDetails]="incentiveDetails"
            (refreshPartnerInput)="refresh()"></app-incentive-details>
        </p-tabpanel>
        <p-tabpanel value="4">
          <app-incentive-payment-info
            [incentiveDetails]="incentiveDetails"></app-incentive-payment-info>
        </p-tabpanel>
        <p-tabpanel value="5">
          <app-incentive-payment-milestone-two
            [incentiveId]="this.incentiveId"
            [isOptOutPartner]="
              isOptOutPartner
            "></app-incentive-payment-milestone-two>
        </p-tabpanel>
        @if (!isMCIWorkshop) {
          <p-tabpanel value="6">
            <app-incentive-poe-submission
              #incentivePoeSubmission
              [incentiveDetails]="incentiveDetails"
              (refreshPartnerInput)="refresh()"></app-incentive-poe-submission>
          </p-tabpanel>
        }
      </p-tabpanels>
    </p-tabs>
  </div>
}
